// Derive a filename for OPFS persistence from a source URL. The persisted
// file is always Turtle (validated upstream), so we force the .ttl suffix.
export function deriveFilename(url: URL): string {
  const segments = url.pathname.split("/").filter((s) => s.length > 0)
  const last = segments[segments.length - 1]
  const base = last ? decodeURIComponent(last) : url.hostname
  return base.toLowerCase().endsWith(".ttl") ? base : `${base}.ttl`
}
